import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const TRANSITION_BG =
  "https://static.prod-images.emergentagent.com/jobs/513c4d98-c117-415c-aaa0-20587ff2b781/images/611807f3dc243a64a1d9fd4fe3065d72aea5beadb11bbdb129f44f9bcd536d17.png";

export const Transition = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      id="transition"
      ref={ref}
      data-testid="transition-section"
      className="relative min-h-[90vh] flex items-center overflow-hidden"
    >
      <motion.div style={{ y }} className="absolute inset-0 z-0">
        <img
          src={TRANSITION_BG}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[#030704]/75" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#030704] via-transparent to-[#030704]/40" />
      </motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 md:py-40 w-full">
        <div className="text-[10px] tracking-[0.4em] uppercase text-[#10B981] flex items-center gap-3 mb-8">
          <span className="h-px w-6 bg-[#10B981]" />
          05 / The Transition
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="font-display text-5xl sm:text-7xl lg:text-[8.5vw] tracking-tighter font-light text-white leading-[0.95] max-w-[14ch]"
        >
          Replacing
          <br />
          <span className="italic font-extralight text-white/50">the </span>
          <span className="italic font-extralight">old world</span>
          <span className="text-[#10B981]">.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="mt-12 max-w-2xl ml-0 lg:ml-auto"
        >
          <p className="font-body text-base md:text-lg text-white/75 leading-[1.8]">
            For decades, the industry relied on{" "}
            <span className="text-white">sheep&apos;s wool</span> for vitamins
            and{" "}
            <span className="text-white">synthetic chemicals</span> for protein
            extraction.{" "}
            <span className="text-[#10B981]">That era is over.</span>{" "}
            By solving the lignocellulosic waste problem, Colossus provides a
            &quot;Clean Label&quot; gateway for global brands to transition into
            the green economy — without losing an ounce of performance.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-px bg-white/[0.06] border border-white/[0.06] max-w-md">
            <div className="bg-[#050907]/80 backdrop-blur-md p-5">
              <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 line-through">
                Sheep&apos;s wool D3
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 line-through mt-1">
                Synthetic extraction
              </div>
            </div>
            <div className="bg-[#0a1410]/80 backdrop-blur-md p-5 border-l border-[#10B981]/30">
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#10B981]">
                Vegan D2
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#10B981] mt-1">
                Botanical green-science
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Transition;
